/* eslint-disable */
import React from 'react'
import { Grid, Row, Col } from 'react-flexbox-grid'
import { useTranslation } from "react-i18next";

import Ic1 from '../../static/icons/why/ic-1.svg'
import Ic2 from '../../static/icons/why/ic-2.svg'
import Ic3 from '../../static/icons/why/ic-3.svg'
import { TitleOne, TextBodyOne } from '../../components/text'
import CardImage from '../../components/card-image'
import { Style } from './why.styles'

const WhyHaloMassage = () => {
  const { t } = useTranslation();
  return (
    <Style>
      <Grid>
        <Row>
          <Col sm={12} xs={12} md={12} lg={12} className="bottom-margin-column">
            <TitleOne display="block" align="center">
              {t('pageSalonMobilPangilan.part4')}
            </TitleOne>
            <TextBodyOne display="block" align="center">
              {t('pageSalonMobilPangilan.part5')}
            </TextBodyOne>
          </Col>
        </Row>
        <Row>
          <Col sm={12} xs={12} md={4} lg={4} className="bottom-margin">
            <CardImage
              noShadow
              titleTop={false}
              image={Ic1}
              title={t('pageSalonMobilPangilan.part6')}
              desc={t('pageSalonMobilPangilan.part7')}
            ></CardImage>
          </Col>
          <Col sm={12} xs={12} md={4} lg={4} className="bottom-margin">
            <CardImage
              noShadow
              titleTop={false}
              image={Ic2}
              title={t('pageSalonMobilPangilan.part8')}
              desc={t('pageSalonMobilPangilan.part9')}
            ></CardImage>
          </Col>
          <Col sm={12} xs={12} md={4} lg={4} className="bottom-margin">
            <CardImage
              noShadow
              titleTop={false}
              image={Ic3}
              title={t('pageSalonMobilPangilan.part10')}
              desc={t('pageSalonMobilPangilan.part11')}
            ></CardImage>
          </Col>
        </Row>
      </Grid>
    </Style>
  )
}

export default WhyHaloMassage
